export const getInitialValues = (activityNote) => {
  return {
    text: activityNote?.text ?? "",
    task_ids: activityNote?.tasks ?? []
  }
}
